import { FormTextarea } from "../../../features/auto-form";
import { IconHeader } from "../../../components";
import { useTranslate } from "../../../features/translation/hooks/use-translation"


const AdditionalInformation = () => {
    const { t } = useTranslate();


    return (
        <div className="container">
            <div className="row">
                <div className="col col-12">
                    <IconHeader title={t("form.additionalDetails.title")} icon="plus"/>
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-sm-8">
                    <FormTextarea 
                        name="additionalInformation"
                        languagesection="form.additionalDetails.additionlInformation"
                        rows="5"
                        maxLength="500"
                    />
                </div>
            </div>
        </div>
    )
}

export default AdditionalInformation;